import classNames from "classnames";
import React, { useEffect, useState, useRef, Children } from "react";
import { createDebounceFn } from "../../utils/utils-lib";
import "../slider/Slider.scss";
const debounce = createDebounceFn(200);
const defaultRenderControls = ({ back, next, currentPage, slidesLength }) => (React.createElement(React.Fragment, null,
    React.createElement("div", { className: "arrow-container" },
        React.createElement("a", { id: "prev", onClick: back, className: classNames("control prev", { "rt-hidden": currentPage === 1 }) }),
        React.createElement("a", { id: "next", onClick: next, className: classNames("control next", {
                "rt-hidden": currentPage === slidesLength,
            }) }))));
export default function Slider({ renderControls = defaultRenderControls, children }) {
    const [page, setPage] = useState(1);
    const [slideSize, setSlideSize] = useState(0);
    let posInitial = 0;
    let posFinal = 0;
    let posX1 = 0;
    let posX2 = 0;
    let allowShift = true;
    const slidesLength = Children.count(children);
    const threshold = 10;
    const refSlides = useRef(null);
    const refSliderWrapper = useRef(null);
    useEffect(() => {
        let slider = refSlides.current;
        //slider.onmousedown = dragStart;
        //slider.addEventListener("touchstart", dragStart);
        //slider.addEventListener("touchend", dragEnd);
        //slider.addEventListener("touchmove", dragAction);
        slider.addEventListener("transitionend", handleTransitionEnd);
        window.addEventListener("resize", handleWindowResize);
        /* Init con dimensione max del container */
        setSlideSize(refSliderWrapper.current.clientWidth);
        return () => {
            //slider.removeEventListener("touchstart", dragStart);
            //slider.removeEventListener("touchend", dragEnd);
            //slider.removeEventListener("touchmove", dragAction);
            slider.removeEventListener("transitionend", handleTransitionEnd);
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    function dragStart(e) {
        e = e || window.event;
        e.preventDefault();
        posInitial = refSlides.current.offsetLeft;
        if (e.type == "touchstart") {
            posX1 = e.touches[0].clientX;
        }
        else {
            posX1 = e.clientX;
            refSlides.current.onmouseup = dragEnd;
            refSlides.current.onmousemove = dragAction;
        }
    }
    function dragEnd(e) {
        var _a;
        posFinal = refSlides.current.offsetLeft;
        let pageNumber = parseInt((_a = refSlides.current) === null || _a === void 0 ? void 0 : _a.getAttribute("current-page"));
        if (posFinal - posInitial < -threshold && pageNumber < slidesLength - 1) {
            shiftSlide(1, "drag");
        }
        else if (posFinal - posInitial > threshold && pageNumber > 0) {
            shiftSlide(-1, "drag");
        }
        else {
            refSlides.current.style.left = posInitial + "px";
        }
        refSlides.current.onmouseup = null;
        refSlides.current.onmousemove = null;
    }
    function dragAction(e) {
        e = e || window.event;
        if (e.type == "touchmove") {
            posX2 = posX1 - e.touches[0].clientX;
            posX1 = e.touches[0].clientX;
        }
        else {
            posX2 = posX1 - e.clientX;
            posX1 = e.clientX;
        }
        refSlides.current.style.left = refSlides.current.offsetLeft - posX2 + "px";
    }
    const shiftMySlide = (dir, action) => {
        debounce(shiftSlide, dir, action);
    };
    function shiftSlide(dir, action) {
        refSlides.current.classList.add("shifting");
        let slideWidth = slideSize;
        if (allowShift) {
            if (action == "") {
                posInitial = refSlides.current.offsetLeft;
            }
            if (dir == 1) {
                refSlides.current.style.left = posInitial - slideWidth + "px";
                setPage((prevPage) => prevPage + 1);
            }
            else if (dir == -1) {
                refSlides.current.style.left = posInitial + slideWidth + "px";
                setPage((prevPage) => prevPage - 1);
            }
        }
        allowShift = false;
    }
    function goToSlide(num) {
        var _a;
        let pageNumber = parseInt((_a = refSlides.current) === null || _a === void 0 ? void 0 : _a.getAttribute("current-page"));
        //Possibili bug prevenuti
        if (num > slidesLength || num <= 0) {
            console.error("numero slide non esistente : " + num);
            return;
        }
        if (num === pageNumber)
            return;
        let slideWidth = slideSize;
        refSlides.current.classList.add("shifting");
        posInitial = refSlides.current.offsetLeft;
        if (num > pageNumber)
            refSlides.current.style.left = posInitial - (num - pageNumber) * slideWidth + "px";
        else
            refSlides.current.style.left = posInitial + (pageNumber - num) * slideWidth + "px";
        setPage(num);
        allowShift = false;
    }
    function resizeMySlider() {
        var _a;
        let pageNumber = parseInt((_a = refSlides.current) === null || _a === void 0 ? void 0 : _a.getAttribute("current-page"));
        let slideSize = refSliderWrapper.current.clientWidth;
        refSlides.current.style.left = (-pageNumber + 1) * slideSize + "px";
        setSlideSize(slideSize);
    }
    function handleTransitionEnd() {
        refSlides.current.classList.remove("shifting");
        allowShift = true;
    }
    const handleWindowResize = () => resizeMySlider();
    return (React.createElement("div", { ref: refSliderWrapper, className: "slider" },
        React.createElement("div", { className: "wrapper" },
            React.createElement("div", { "current-page": page, ref: refSlides, className: "slides" }, Children.map(children, (c, i) => {
                return (React.createElement("div", { id: String(i + 1), key: String(i), className: "slide", style: { width: slideSize } }, c));
            }))),
        React.createElement("div", { className: "slider-controls" }, renderControls({
            back: () => shiftMySlide(-1, ""),
            goToSlide: (slide) => goToSlide(slide),
            next: () => shiftMySlide(1, ""),
            currentPage: page,
            slidesLength,
        }))));
}
